import { render } from "./SimpleChart.vue?vue&type=template&id=9e5230fe&scoped=true"
import script from "./SimpleChart.vue?vue&type=script&lang=js"
export * from "./SimpleChart.vue?vue&type=script&lang=js"

import "./SimpleChart.vue?vue&type=style&index=0&id=9e5230fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e5230fe"]])

export default __exports__